import WebSocket from 'ws';
import { sendWsMessage } from './create-ws-bridge.js';
import { getBridgeRoot } from '../files/cwd/index.js';
import { discoverLocalSkillsAsync } from '../skills/discovery.js';
import { detectLocalAgentTypes } from '../agents/detect-local-agent-types.js';
import { isCliImmediateShutdownRequested } from '../runtime/cli-process-interrupt.js';
import type { LogFn } from '../log.js';

export function createSendLocalSkillsReport(getWs: () => WebSocket | null, logFn: LogFn): () => void {
  return () => {
    setImmediate(() => {
      void (async () => {
        try {
          const socket = getWs();
          if (!socket || socket.readyState !== WebSocket.OPEN) return;
          const skills = await discoverLocalSkillsAsync(getBridgeRoot());
          sendWsMessage(socket, { type: 'local_skills', skills });
        } catch (e) {
          logFn(
            `[Bridge service] Local skills report failed: ${e instanceof Error ? e.message : String(e)}`,
          );
        }
      })();
    });
  };
}

export function createReportAutoDetectedAgents(getWs: () => WebSocket | null, logFn: LogFn): () => Promise<void> {
  return async () => {
    if (isCliImmediateShutdownRequested()) return;
    try {
      const types = await detectLocalAgentTypes();
      const socket = getWs();
      if (socket && socket.readyState === WebSocket.OPEN) {
        sendWsMessage(socket, { type: 'auto_detected_agents_report', agentTypes: types });
      }
    } catch (e) {
      logFn(
        `[Bridge service] Auto-detected agents report failed: ${e instanceof Error ? e.message : String(e)}`,
      );
    }
  };
}
